import React from "react";
import AboutSection from "../AboutSection/AboutSection";
const About = () => {
  return (
    <>
      <AboutSection></AboutSection>
    </>
  );
};

export default About;
